import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { VaultGate } from "@/features/vault/components/vault-gate";
import { VaultHealth } from "@/features/vault/components/vault-health";

/** Vault security health (requires being unlocked). */
function SecurityPage() {
  return (
    <VaultGate>
      <VaultHealth />
    </VaultGate>
  );
}

export const securityRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/security",
  component: SecurityPage,
});
